import styled from 'styled-components';

const Container = styled.div`
  background-color: #d5e5f0;
  padding: 0 12px 12px 12px;
  border-radius: 8px;

  div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    padding: 16px 16px 16px 0;

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export default Container;
